import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { Element } from '../../../html/element'
import PropTypes from 'prop-types'

export const ScoreReportingDate = ({ val }) => {
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <Element
      elementName="span"
      className="fstItalic ml1"
      style={{ color: '#3A414B' }}
    >
      <Translate
        value="common.order.factSheet.SCORE_REPORTING_DATE"
        year={formatDateTime(val, FORMAT.MONTH_YEAR, locale)}
      />
    </Element>
  )
}

ScoreReportingDate.propTypes = {
  val: PropTypes.string,
}
